import { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row, Switch } from 'antd';
import { drawerWidth, formItemLayout, notifyMessages } from '../../utils/constants';
import { DrawerFormButtons } from '../../components/common/drawersFormButtons';
import SuppliersServices from '../../services/suppliersServices';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useCurrentUserContext } from '../../context/currentUserContext';
import { errorAlertDisplay } from '../../utils/functions';


const NewSupplier = ({ open, onClose, getSuppliers }) => {

    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const { currentUser } = useCurrentUserContext();

    const saveData = async (values) => {
        // values["categoryID"] = currentUser.lastSelectedCategory;
        setLoadingButton(true);
        try {
            const respData = await SuppliersServices.createSupplier(values);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                setLoadingButton(false);
                getSuppliers();
                onClose();
            }
            else {
                errorAlertDisplay(respData);
                setLoadingButton(false);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingButton(false);
        }
    }


    return (
        <Drawer
            title="Aggiungi Fornitore"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"newSupplier"} />
            }
        >
            <Form
                id="newSupplier"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Nome"
                            name="name"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Partita Iva"
                            name="vatCode"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Abilitato"
                            name="enabled"
                            valuePropName="checked"
                            initialValue={true}
                        >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}
export default NewSupplier;